import 'js/app/setupEnvironment';
import user from 'js/lib/user';

import courseV2Routes from 'bundles/course-v2/routes';
import loggedOutOndemandRoute from 'bundles/ondemand/loggedOutOndemandRoute';

import 'css!bundles/ondemand/styl/index';
import 'css!pages/open-course/index';

export default function () {
  return user.isAuthenticatedUser() ? courseV2Routes : loggedOutOndemandRoute;
}
